import { useEffect, useState } from 'react';

import { listContacts } from 'services/contact';
import { totalCountEvent } from 'services/generalServices';

export default function useEventLocation() {
  const [eventLocations, setEventLocations] = useState([]);
  const [isEventsLoading, setIsEventsLoading] = useState(false);

  const loadEventLocations = () => {
    setIsEventsLoading(true);
    totalCountEvent('contact')
      .then((response) => {
        listContacts('', '', '', '', true, true, '', response?.data)
          .then((response) => {
            if (response?.data?.contacts?.length > 0) {
              setEventLocations(response?.data?.contacts || []);
            }
          })
          .catch((err) => {
            console.log('err', err);
          })
          .finally(() => setIsEventsLoading(false));
      })
      .catch((err) => {
        setIsEventsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    loadEventLocations();
  }, []);

  return { eventLocations, isEventsLoading, loadEventLocations };
}
